// extracted by mini-css-extract-plugin
export default {"searchBlock":"styles_searchBlock__M0Tkc","inputHolder":"styles_inputHolder__ktyQr","inputSpinner":"styles_inputSpinner__ATUJK"};